<template>
    <div>
        <van-sticky>
            <div class="shopBack">
                <img class="logo" src="@/assets/navbar/logo_white.png" alt="" @click="handleGoHome">
                <div class="center">
                    {{ centerText }}
                </div>
                <div class="right">
                    <img class="icon-white" src="@/assets/shop/share.png" alt="" @click="handleShare">
                    <img v-if="localIsFavorite" src="@/assets/shop/heart_red.png" alt="" @click="handleFavorite">
                    <img v-else class="icon-white" src="@/assets/shop/heart_blue.png" alt="" @click="handleFavorite">
                    <img class="icon-white" src="@/assets/navbar/Frame_white.png" alt="" @click="showUserDrawer = true">
                </div>
            </div>
            <van-overlay :show="showSharePopup" @click="showSharePopup = false">
                <div class="share-popup-wrapper" @click.stop>
                    <div class="share-popup">
                        <div class="share-header">
                            <div class="share-title">Share</div>
                            <img src="@/assets/navbar/close.png" alt="" class="close-icon" @click="showSharePopup = false">
                        </div>
                        <div class="share-facebook-btn" @click="handleShareToFacebook">
                            <span>Share to</span>
                            <img src="@/assets/shop/facebook.svg" alt="facebook" class="fb-icon" />
                            <span>Facebook</span>
                        </div>
                        <div class="share-link-box">
                            <div class="share-link-text">{{ shareUrl }}</div>
                        </div>
                        <div class="copy-btn" @click="handleCopyLink">COPY</div>
                    </div>
                </div>
            </van-overlay>
        </van-sticky>
        <UserDrawer v-model="showUserDrawer" />
    </div>
</template>
<script>
import { Toast } from 'vant';
import { ensureLoggedInOrPrompt } from '@/utils/authGuard'
import UserDrawer from '@/components/UserCenter/Drawer.vue'

export default {
    name:'ShopBack',
    props:{
        centerText:{
            type:String,
            default:''
        },
        shop_supplier_id:{
            type:String,
            default:''
        },
        favoriteStatus:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            localIsFavorite: false,
            showSharePopup: false,
            showUserDrawer: false
        }
    },
    components:{
        UserDrawer
    },
    watch: {
        favoriteStatus: {
            immediate: true,
            handler(value) {
                this.localIsFavorite = !!value
            }
        }
    },
    computed: {
        shareUrl() {
            const appId = (this.$route && this.$route.query && this.$route.query.app_id) || 10001
            const shopSupplierId = this.shop_supplier_id || (this.$route && this.$route.query && this.$route.query.shop_supplier_id) || ''
            return `https://www.hwm.red/index.php/api/share/shop?app_id=${appId}&shop_supplier_id=${shopSupplierId}`
        }
    },
    methods:{
        handleGoHome(){
            this.$router.push('/').catch(() => {})
        },
        handleShare(){
            this.showSharePopup = true
        },
        handleShareToFacebook(){
            const url = encodeURIComponent(this.shareUrl)
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank')
        },
        handleCopyLink(){
            navigator.clipboard.writeText(this.shareUrl).then(() => {
                Toast.success('Link copied')
            }).catch(() => {
                const input = document.createElement('input')
                input.value = this.shareUrl
                document.body.appendChild(input)
                input.select()
                document.execCommand('copy')
                document.body.removeChild(input)
                Toast.success('Link copied')
            })
        },
        async handleFavorite(){
            const canProceed = await ensureLoggedInOrPrompt()
            if (!canProceed) return

            this.$api.getShopFavorite({ pid: this.shop_supplier_id, type: 10 }).then(res => {
                if(res.code == 1){
                    if(this.localIsFavorite){
                        Toast.success('Removed from favorites')
                    }else{
                        Toast.success('Added to favorites')
                    }
                    this.$emit('favorite-updated')
                }else{
                    Toast.fail(res.msg || 'Operation failed')
                }
            }).catch((error) => {
                if (error && (error._shown || error._authRequired)) {
                    return
                }
                Toast.fail('Operation failed')
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .shopBack{
        position: relative;
        width: 100%;
        padding: 0 1rem;
        background: #1A3232;
        width: 100%;
        height: 2.75rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        .logo{
            width: 4.0625rem;
            height: 1.5rem;
            display: block;
            flex-shrink: 0;
        }
        .center{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
        }
        img{
            width: 1.5rem;
            height: 1.5rem;
            display: block;
        }
        .icon-white{
            filter: brightness(0) invert(1);
        }
        .right{
            display: flex;
            align-items: center;
            gap: 1rem;
        }
    }
    .share-popup-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 0 1.5rem;
        box-sizing: border-box;
    }
    .share-popup {
        width: 100%;
        background: #fff;
        border-radius: 0.5rem;
        padding: 1rem;
        box-sizing: border-box;
        .share-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;
            .share-title {
                font-size: 1rem;
                font-weight: 500;
                color: #333;
            }
            .close-icon {
                width: 1.25rem;
                height: 1.25rem;
                cursor: pointer;
            }
        }
        .share-facebook-btn {
            width: 100%;
            height: 3rem;
            background: #2d5a5c;
            border: none;
            border-radius: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
            color: #fff;
            font-size: 0.875rem;
            cursor: pointer;
            margin-bottom: 1rem;
            .fb-icon {
                width: 1.5rem;
                height: 1.5rem;
                filter: brightness(0) invert(1);
            }
        }
        .share-link-box {
            width: 100%;
            padding: 1rem;
            background: #F5F5F5;
            border-radius: 0.5rem;
            margin-bottom: 1rem;
            box-sizing: border-box;
            .share-link-text {
                font-size: 0.875rem;
                color: #666;
                word-break: break-all;
                line-height: 1.5;
            }
        }
        .copy-btn {
            width: 100%;
            height: 3rem;
            background: #fff;
            border: 1px solid #E5E5E5;
            border-radius: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
            color: #333;
            cursor: pointer;
        }
    }
</style>
